export default "/awards-banner.182c438c-a2441e.webp";